/**
 * Parse decimal hours from API values like 1.4, "1.4", or "1.4h".
 */
const parseHoursValue = value => {
  if (value == null || value === "") return 0
  if (typeof value === "number") {
    return Number.isFinite(value) ? Math.max(0, value) : 0
  }

  const text = String(value).trim()
  if (!text) return 0

  const asNumber = Number(text)
  if (Number.isFinite(asNumber)) return Math.max(0, asNumber)

  // Dashboard stats: "1.4h" / "1.4 hrs"
  const hoursOnly = text.match(/^([\d.]+)\s*h(?:rs?|ours?)?$/i)
  if (hoursOnly) {
    const n = Number(hoursOnly[1])
    return Number.isFinite(n) ? Math.max(0, n) : 0
  }

  return 0
}

/**
 * Convert a decimal-hours value (e.g. 54, 1.5, "1.4h") to "54h 00m 00s".
 */
export const formatDurationFromHours = valueInHours => {
  const totalSeconds = Math.max(
    0,
    Math.round(parseHoursValue(valueInHours) * 3600),
  )
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const pad = num => String(num).padStart(2, "0")
  return `${hours}h ${pad(minutes)}m ${pad(seconds)}s`
}
